import React from "react";
import Avatar from "@streeteasy/design-system/avatar";
import userTypes from "@streeteasy/design-system/avatar/userTypes";
import calloutCardThemes from "@streeteasy/design-system/callout-card/constants/calloutCardThemes";
import { HorizontalCalloutCardButton } from "@streeteasy/design-system/callout-card/HorizontalCalloutCard";
import componentSizes from "@streeteasy/design-system/constants/componentSizes";
import { number } from "prop-types";

import { agentMatchItemPropType } from "../../../../propTypes";
import { useUIBehavior } from "../../redux/hooks/uiHooks";
import * as S from "./styled";

const ConnectWithAgentCTA = ({ agentMatchItem, propertyId }) => {
  const { openExpertMatchDrawer } = useUIBehavior();
  const bannerDescription = `${agentMatchItem.name} has sold ${agentMatchItem.homesSoldSimilar} homes like yours and is ready to help`;
  const handleAnalyticsLAMBannerClick = () => {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "homepage",
      event_action: "impressions_for_listing_agent",
      event_label: `expert_contact_id=${agentMatchItem.contactId}|uuid=${agentMatchItem.uuid}|property_id=${propertyId}`
    });
  };
  const handleBannerClick = () => {
    openExpertMatchDrawer();
    handleAnalyticsLAMBannerClick();
  };

  return (
    <S.ListingAgentMatchContainer>
      <S.Title>Sell the smarter way</S.Title>
      <HorizontalCalloutCardButton
        callToActionCopy="Learn more"
        description={bannerDescription}
        headline="A proven agent matched to your needs"
        illustration={
          <Avatar
            className="a11y"
            isPro={agentMatchItem.isPro}
            size={componentSizes.SM}
            src={agentMatchItem.photoUrl}
            userType={userTypes.PARTNER}
          />
        }
        onClick={handleBannerClick}
        theme={calloutCardThemes.BLUE}
      />
      <S.Copy>
        {agentMatchItem.brokerageAddress}{" "}
        <S.Link href="/sell-your-home">View owner dashboard</S.Link>
      </S.Copy>
      <S.CaptionText>
        {agentMatchItem.name} is a StreetEasy Expert. Experts are licensed real
        estate agents with verified experience in the areas you’re searching.
        StreetEasy earns a referral fee from successful Experts’ transactions,
        at no cost to you.
      </S.CaptionText>
    </S.ListingAgentMatchContainer>
  );
};

ConnectWithAgentCTA.propTypes = {
  agentMatchItem: agentMatchItemPropType.isRequired,
  propertyId: number.isRequired
};

export default ConnectWithAgentCTA;
